<template>
  <label class="checkbox-container g-16 the-same-gap full-width">
    <input @change="$emit('update:modelValue', value)"
           :checked="String(modelValue) === String(value)"
           :key="`${modelValue}-${value}`"
           :name="name"
           :ref="'radio'"
           :id="id"
           type="radio"/>
    <span class="checkmark flex-center" style="display: flex">
      <span class="circle"></span>
    </span>
    <span v-if="!hover" class="text full-width">{{ text }}</span>
    <span v-else class="text full-width radio-with-hover">{{ text }}
      <Help :top="true" :right="true">
    {{ hover }}
  </Help>
    </span>
  </label>
</template>
<script>
import CheckIcon from "~/components/icons/CheckIcon.vue";
import Help from "~/components/molecules/Help.vue";

export default {
  components: {CheckIcon, Help},
  props: {
    text: String,
    id: String,
    name: String,
    checked: Boolean,
    hover: String,
    value: [String, Number],
    modelValue: [String, Number]
  },
  emits: ['update:modelValue'],

  mounted() {
    if (String(this.modelValue) === String(this.value)) {
      this.$refs.radio.checked = true
    }
  },
}

</script>

<style scoped lang="scss">
.checkbox-container {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
}

.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  min-height: 24px;
  min-width: 24px;
  max-height: 24px;
  max-width: 24px;
  border: 1px solid $black;
  border-radius: 100%;

  &:hover {
    background-color: $grey;
  }
}

svg {
  display: none;
}

.checkbox-container input:checked ~ .checkmark {
  background-color: $white;

  span {
    width: 12px;
    height: 12px;
    background: $black;
  }
}

.checkmark::after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox-container input:checked ~ .checkmark::after {
  display: block;
}

.radio-with-hover {
  display: flex;
  align-items: center;
  gap: 4px;
}

.radio-hover-image {
  &:hover {
    width: 25px !important;
  }
}

</style>
